// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetPlannerAreaId } from './FleetPlannerAreaId'
import {
  FleetPlannerAreaNavigation,
  FleetPlannerAreaNavigationIcon,
} from './FleetPlannerAreaNavigation'
import { FleetPlannerAreaRoutes } from './FleetPlannerAreaRoutes'

const LazyFleetPlannerComponent = lazy(() => import('./FleetPlannerArea'))

const FleetPlannerComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetPlannerComponent />
  </SuspenseLoadingWrapper>
)

export const FleetPlannerArea = {
  id: FleetPlannerAreaId,
  requiredRight: BoumRight.CAMPAIGN_CONFIGURATION_CRUD,
  Icon: FleetPlannerAreaNavigationIcon,
  NavigationComponent: FleetPlannerAreaNavigation,
  route: {
    path: FleetPlannerAreaRoutes.route,
    component: FleetPlannerComponent,
  },
}
